import React from "react";
import MainContent from "layouts/MainContent";
import Dashboard from "features/kms/dashboard/Dashboard";
import FeaturePlaceholder from "features/kms/common/FeaturePlaceholder";
import PersonalFieldCatalog from "features/kms/personal-fields/PersonalFieldCatalog";
import VerificationBoard from "features/kms/verification/VerificationBoard";
import DocumentBoard from "features/kms/documents/DocumentBoard";
import SystemTablePage from "features/kms/system/SystemTablePage";
import SettingsManagementPage from "features/kms/system/SettingsManagementPage";
import GroupManagementPage from "features/kms/system/GroupManagementPage";
import UserAdministrationPage from "features/kms/system/UserAdministrationPage";
import UserContextManagementPage from "features/kms/system/UserContextManagementPage";
import PermissionManagementPage from "features/kms/system/PermissionManagementPage";
import MenuManagementPage from "features/kms/system/MenuManagementPage";
import PengelolaanPenggunaPage from "features/kms/administrasi/PengelolaanPenggunaPage";
import OrganizationManagementPage from "features/kms/organisasi/OrganizationManagementPage";
import OrganizationProfilePage from "features/kms/organisasi/OrganizationProfilePage";
import OrganizationRelationPage from "features/kms/organisasi/OrganizationRelationPage";
import PengurusManagementPage from "features/kms/organisasi/PengurusManagementPage";
import MyProfilePage from "features/kms/profile/MyProfilePage";
import ChangePasswordPage from "features/kms/profile/ChangePasswordPage";
import SystemGuidePage from "features/kms/profile/SystemGuidePage";
import { IssueManagementPage, IssueReportPage } from "features/kms/profile/IssueReportPage";
import PersonalMembershipHistoryPage from "features/kms/profile/PersonalMembershipHistoryPage";
import PersonalEducationHistoryPage from "features/kms/profile/PersonalEducationHistoryPage";
import {
  PersonalAchievementPage,
  PersonalCertificationPage,
  VerificationAchievementSubmissionPage,
  VerificationCertificationSubmissionPage,
} from "features/kms/profile/PersonalCapaianPages";
import {
  CapaianPrestasiCaborPage,
  CapaianPrestasiIndukOrganisasiPage,
  CapaianPrestasiKlubPage,
  CapaianPrestasiSDMPage,
  CapaianSertifikasiSDMPage,
} from "features/kms/profile/CapaianSDMPages";
import CaborManagementPage from "features/kms/master/CaborManagementPage";
import CaborMonitoringAktifitasPage from "features/kms/master/CaborMonitoringAktifitasPage";
import CaborRekapitulasiPage from "features/kms/master/CaborRekapitulasiPage";
import NomorPertandinganManagementPage from "features/kms/master/NomorPertandinganManagementPage";
import SDMKeolahragaanPage from "features/kms/sdm/SDMKeolahragaanPage";
import KejuaraanManagementPage from "features/kms/kegiatan/KejuaraanManagementPage";
import PengelolaKejuaraanManagementPage, {
  OperatorCaborManagementPage,
} from "features/kms/kegiatan/PengelolaKejuaraanManagementPage";
import PelatihanManagementPage from "features/kms/kegiatan/PelatihanManagementPage";
import {
  KejuaraanAdminAtletPeraihMedaliPage,
  KejuaraanAdminLaporPerolehanMedaliPage,
  KejuaraanAdminRekapMedaliAtletPage,
  KejuaraanAdminRekapMedaliKontingenPage,
} from "features/kms/kegiatan/KejuaraanAdminMedaliPages";
import {
  KejuaraanAdminEvaluasiCapaianEmasPage,
  KejuaraanAdminEvaluasiPeluangPage,
  KejuaraanAdminTargetMedaliPage,
} from "features/kms/kegiatan/KejuaraanAdminEvaluasiPages";
import {
  KejuaraanAdminCaborPage,
  KejuaraanAdminKontingenPage,
  KejuaraanAdminNomorPage,
  KejuaraanAdminSDMPage,
} from "features/kms/kegiatan/KejuaraanAdminPages";
import Logout from "pages/Logout";

const allGroups = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
const adminGroups = [1, 2, 3, 4, 5];
const dataCaborGroups = [1, 2, 3, 4, 5, 12];
const systemGroups = [1];
const administrasiPenggunaGroups = [1, 2, 3, 4, 5];
const verifierGroups = [1, 6];
const koniProvOnlyGroups = [1];
const koniKabkotaOnlyGroups = [2];
const adminKoniKabkotaGroups = [3];
const adminKejuaraanGroups = [8, 9];
const adminKejuaraanOnlyGroups = [8];
const personalGroups = [10];
const orgCaborOnlyGroups = [3, 10];
const klubOnlyGroups = [3, 4, 10];
const dataOrganisasiGroups = [3, 4, 5];
const dataOrganisasiParentGroups = [2, 3, 4, 5];
const verificationSubmissionGroups = [3, 4];
const organizationCapaianGroups = [3, 4, 5];

function page(title, description) {
  return (
    <MainContent
      title={title}
      content={<FeaturePlaceholder title={title} description={description} />}
    />
  );
}

export const ACLData = {
  1000: {
    groups: allGroups,
    to: "/",
    comp: <MainContent title="Dashboard" content={<Dashboard />} />,
  },
  2000: {
    groups: [],
    to: "#",
    comp: <MainContent title="Organisasi" content={<Dashboard />} />,
  },
  2001: {
    groups: [],
    to: "/organisasi/koni-provinsi",
    comp: (
      <MainContent
        title="KONI Provinsi"
        content={
          <OrganizationManagementPage
            title="KONI Provinsi"
            description="Pengelolaan organisasi KONI tingkat provinsi. Data ini tidak memakai cabor dan tidak memiliki organisasi induk."
            listUrl="/organisasi-koni-provinsi"
            jenisKode="KONI"
            defaultTingkatKode="PROVINSI"
            showTingkatField={false}
            showParentField={false}
            showCaborField={false}
          />
        }
      />
    ),
  },
  2002: {
    groups: [2],
    to: "/organisasi/koni-kabkota",
    comp: (
      <MainContent
        title="KONI Kab/Kota"
        content={
          <OrganizationManagementPage
            title="KONI Kabupaten/Kota"
            description="Pengelolaan organisasi KONI tingkat kabupaten/kota."
            listUrl="/organisasi-koni-kabkota"
            jenisKode="KONI"
            defaultTingkatKode="KABUPATEN_KOTA"
            showTingkatField={false}
            showParentField={false}
            showCaborField={false}
            parentFilter={(item) =>
              String(item?.jenis_kode || "").toUpperCase() === "KONI"
            }
          />
        }
      />
    ),
  },
  2005: {
    groups: [],
    to: "/organisasi/relasi",
    comp: (
      <MainContent
        title="Relasi Organisasi"
        content={<OrganizationRelationPage />}
      />
    ),
  },
  2900: {
    groups: dataOrganisasiParentGroups,
    to: "#",
    comp: <MainContent title="Data Organisasi" content={<Dashboard />} />,
  },
  2910: {
    groups: dataOrganisasiGroups,
    to: "/data-organisasi/profil",
    comp: (
      <MainContent
        title="Profil"
        content={<OrganizationProfilePage />}
      />
    ),
  },
  2920: {
    groups: dataOrganisasiGroups,
    to: "/data-organisasi/pengurus",
    comp: (
      <MainContent
        title="Pengurus"
        content={<PengurusManagementPage />}
      />
    ),
  },
  3000: {
    groups: adminGroups,
    to: "#",
    comp: <MainContent title="SDM Keolahragaan" content={<Dashboard />} />,
  },
  3001: {
    groups: adminGroups,
    to: "/sdm/personal",
    comp: page(
      "Semua Personal",
      "Pusat data personal KMS lintas peran olahraga.",
    ),
  },
  3002: {
    groups: adminGroups,
    to: "/sdm/atlet",
    comp: (
      <MainContent
        title="Atlet"
        content={<SDMKeolahragaanPage title="Atlet" rolePath="atlet" />}
      />
    ),
  },
  3003: {
    groups: adminGroups,
    to: "/sdm/pelatih",
    comp: (
      <MainContent
        title="Pelatih"
        content={<SDMKeolahragaanPage title="Pelatih" rolePath="pelatih" />}
      />
    ),
  },
  3004: {
    groups: adminGroups,
    to: "/sdm/wasit",
    comp: (
      <MainContent
        title="Wasit"
        content={<SDMKeolahragaanPage title="Wasit" rolePath="wasit" />}
      />
    ),
  },
  3005: {
    groups: adminGroups,
    to: "/sdm/juri",
    comp: (
      <MainContent
        title="Juri"
        content={<SDMKeolahragaanPage title="Juri" rolePath="juri" />}
      />
    ),
  },
  3007: {
    groups: adminGroups,
    to: "/sdm/manajer",
    comp: (
      <MainContent
        title="Manajer"
        content={<SDMKeolahragaanPage title="Manajer" rolePath="manajer" />}
      />
    ),
  },
  3008: {
    groups: adminGroups,
    to: "/sdm/mekanik",
    comp: (
      <MainContent
        title="Mekanik"
        content={<SDMKeolahragaanPage title="Mekanik" rolePath="mekanik" />}
      />
    ),
  },
  3006: {
    groups: adminGroups,
    to: "/sdm/official",
    comp: (
      <MainContent
        title="Official"
        content={<SDMKeolahragaanPage title="Official" rolePath="official" />}
      />
    ),
  },
  4000: {
    groups: adminGroups,
    to: "#",
    comp: <MainContent title="Keanggotaan" content={<Dashboard />} />,
  },
  4001: {
    groups: adminGroups,
    to: "/keanggotaan/aktif",
    comp: page(
      "Keanggotaan Aktif",
      "Daftar keanggotaan aktif lintas organisasi dan cabor.",
    ),
  },
  4002: {
    groups: adminGroups,
    to: "/keanggotaan/riwayat",
    comp: page("Riwayat", "Riwayat keanggotaan dan perpindahan personal."),
  },
  4003: {
    groups: adminGroups,
    to: "/keanggotaan/mutasi",
    comp: page(
      "Mutasi/Perpindahan",
      "Pengelolaan proses mutasi dan perpindahan.",
    ),
  },
  5000: {
    groups: adminKoniKabkotaGroups,
    to: "#",
    comp: <MainContent title="Kegiatan" content={<Dashboard />} />,
  },
  5005: {
    groups: adminKoniKabkotaGroups,
    to: "/kegiatan/kejuaraan",
    comp: (
      <MainContent
        title="Kejuaraan"
        content={<KejuaraanManagementPage />}
      />
    ),
  },
  5006: {
    groups: adminKoniKabkotaGroups,
    to: "/kegiatan/pengelola-kejuaraan",
    comp: (
      <MainContent
        title="Admin Kejuaraan"
        content={<PengelolaKejuaraanManagementPage />}
      />
    ),
  },
  5007: {
    groups: adminKoniKabkotaGroups,
    to: "/kegiatan/pelatihan",
    comp: (
      <MainContent
        title="Pelatihan"
        content={<PelatihanManagementPage />}
      />
    ),
  },
  5500: {
    groups: adminGroups,
    to: "#",
    comp: <MainContent title="Kejuaraan & Prestasi" content={<Dashboard />} />,
  },
  5501: {
    groups: adminGroups,
    to: "/kejuaraan",
    comp: page("Kejuaraan", "Pengelolaan data kejuaraan."),
  },
  5502: {
    groups: adminGroups,
    to: "/nomor-pertandingan",
    comp: page("Nomor Pertandingan", "Master dan event nomor pertandingan."),
  },
  5503: {
    groups: adminGroups,
    to: "/prestasi",
    comp: page("Prestasi", "Pengelolaan prestasi individu dan beregu."),
  },
  5504: {
    groups: adminGroups,
    to: "/prestasi/rekap-medali",
    comp: page(
      "Rekap Medali",
      "Rekap medali dari hasil kejuaraan dan prestasi.",
    ),
  },
  5600: {
    groups: adminKejuaraanGroups,
    to: "#",
    comp: <MainContent title="Peserta Kejuaraan" content={<Dashboard />} />,
  },
  5610: {
    groups: adminKejuaraanGroups,
    to: "/kejuaraan-admin/kontingen",
    comp: <MainContent title="Kontingen" content={<KejuaraanAdminKontingenPage />} />,
  },
  5620: {
    groups: adminKejuaraanGroups,
    to: "/kejuaraan-admin/cabor",
    comp: <MainContent title="Cabor" content={<KejuaraanAdminCaborPage />} />,
  },
  5630: {
    groups: adminKejuaraanGroups,
    to: "/kejuaraan-admin/nomor-pertandingan",
    comp: <MainContent title="Nomor Pertandingan" content={<KejuaraanAdminNomorPage />} />,
  },
  5640: {
    groups: adminKejuaraanGroups,
    to: "/kejuaraan-admin/atlet",
    comp: <MainContent title="Atlet" content={<KejuaraanAdminSDMPage title="Atlet" rolePath="ATLET" />} />,
  },
  5650: {
    groups: adminKejuaraanGroups,
    to: "/kejuaraan-admin/pelatih",
    comp: <MainContent title="Pelatih" content={<KejuaraanAdminSDMPage title="Pelatih" rolePath="PELATIH" />} />,
  },
  5660: {
    groups: adminKejuaraanGroups,
    to: "/kejuaraan-admin/wasit",
    comp: <MainContent title="Wasit" content={<KejuaraanAdminSDMPage title="Wasit" rolePath="WASIT" />} />,
  },
  5670: {
    groups: adminKejuaraanGroups,
    to: "/kejuaraan-admin/juri",
    comp: <MainContent title="Juri" content={<KejuaraanAdminSDMPage title="Juri" rolePath="JURI" />} />,
  },
  5680: {
    groups: adminKejuaraanGroups,
    to: "/kejuaraan-admin/manajer",
    comp: <MainContent title="Manajer" content={<KejuaraanAdminSDMPage title="Manajer" rolePath="MANAJER" />} />,
  },
  5690: {
    groups: adminKejuaraanGroups,
    to: "/kejuaraan-admin/mekanik",
    comp: <MainContent title="Mekanik" content={<KejuaraanAdminSDMPage title="Mekanik" rolePath="MEKANIK" />} />,
  },
  5695: {
    groups: adminKejuaraanGroups,
    to: "/kejuaraan-admin/official",
    comp: <MainContent title="Official" content={<KejuaraanAdminSDMPage title="Official" rolePath="OFFICIAL" />} />,
  },
  5700: {
    groups: adminKejuaraanGroups,
    to: "#",
    comp: <MainContent title="Rekapitulasi Medali" content={<Dashboard />} />,
  },
  5710: {
    groups: adminKejuaraanGroups,
    to: "/kejuaraan-admin/perolehan-medali/lapor",
    comp: (
      <MainContent
        title="Pencatatan Medali"
        content={<KejuaraanAdminLaporPerolehanMedaliPage />}
      />
    ),
  },
  5720: {
    groups: adminKejuaraanGroups,
    to: "/kejuaraan-admin/perolehan-medali/rekap-kontingen",
    comp: (
      <MainContent
        title="Rekap Medali Kontingen"
        content={<KejuaraanAdminRekapMedaliKontingenPage />}
      />
    ),
  },
  5730: {
    groups: adminKejuaraanGroups,
    to: "/kejuaraan-admin/perolehan-medali/atlet",
    comp: (
      <MainContent
        title="Atlet Peraih Medali"
        content={<KejuaraanAdminAtletPeraihMedaliPage />}
      />
    ),
  },
  5740: {
    groups: adminKejuaraanGroups,
    to: "/kejuaraan-admin/perolehan-medali/rekap-atlet",
    comp: (
      <MainContent
        title="Rekap Medali Atlet"
        content={<KejuaraanAdminRekapMedaliAtletPage />}
      />
    ),
  },
  5800: {
    groups: adminKejuaraanGroups,
    to: "#",
    comp: <MainContent title="Evaluasi" content={<Dashboard />} />,
  },
  5810: {
    groups: adminKejuaraanGroups,
    to: "/kejuaraan-admin/evaluasi/monitoring-medali",
    comp: (
      <MainContent
        title="Monitoring Medali"
        content={<KejuaraanAdminTargetMedaliPage />}
      />
    ),
  },
  5820: {
    groups: adminKejuaraanGroups,
    to: "/kejuaraan-admin/evaluasi/peluang",
    comp: (
      <MainContent
        title="Evaluasi Peluang"
        content={<KejuaraanAdminEvaluasiPeluangPage />}
      />
    ),
  },
  5830: {
    groups: adminKejuaraanGroups,
    to: "/kejuaraan-admin/evaluasi/capaian-emas",
    comp: (
      <MainContent
        title="Evaluasi Capaian Emas"
        content={<KejuaraanAdminEvaluasiCapaianEmasPage />}
      />
    ),
  },
  5890: {
    groups: adminKejuaraanOnlyGroups,
    to: "/kejuaraan-admin/operator-cabor",
    comp: (
      <MainContent
        title="Operator Cabor"
        content={<OperatorCaborManagementPage />}
      />
    ),
  },
  6000: {
    groups: adminGroups,
    to: "#",
    comp: <MainContent title="Verifikasi" content={<Dashboard />} />,
  },
  6001: {
    groups: verifierGroups,
    to: "/verifikasi/pengajuan-baru",
    comp: (
      <MainContent
        title="Pengajuan Baru"
        content={<VerificationBoard status="DIAJUKAN" />}
      />
    ),
  },
  6002: {
    groups: verifierGroups,
    to: "/verifikasi/perlu-perbaikan",
    comp: (
      <MainContent
        title="Perlu Perbaikan"
        content={<VerificationBoard status="PERLU_PERBAIKAN" />}
      />
    ),
  },
  6003: {
    groups: verifierGroups,
    to: "/verifikasi/terverifikasi",
    comp: (
      <MainContent
        title="Terverifikasi"
        content={<VerificationBoard status="TERVERIFIKASI" />}
      />
    ),
  },
  6004: {
    groups: verifierGroups,
    to: "/verifikasi/ditolak",
    comp: (
      <MainContent
        title="Ditolak"
        content={<VerificationBoard status="DITOLAK" />}
      />
    ),
  },
  6005: {
    groups: verifierGroups,
    to: "/verifikasi/riwayat",
    comp: (
      <MainContent
        title="Riwayat Verifikasi"
        content={<VerificationBoard status="" />}
      />
    ),
  },
  7000: {
    groups: allGroups,
    to: "/laporan",
    comp: <MainContent title="Dokumen Terbaru" content={<DocumentBoard />} />,
  },
  7500: {
    groups: dataCaborGroups,
    to: "#",
    comp: <MainContent title="Data Cabang Olahraga" content={<Dashboard />} />,
  },
  7501: {
    groups: dataCaborGroups,
    to: "/master/cabor",
    comp: (
      <MainContent title="Cabang Olahraga" content={<CaborManagementPage />} />
    ),
  },
  7502: {
    groups: orgCaborOnlyGroups,
    to: "/organisasi/cabor",
    comp: (
      <MainContent
        title="Induk Organisasi Cabor"
        content={
          <OrganizationManagementPage
            title="Induk Organisasi Cabor"
            description="Pengelolaan induk organisasi cabang olahraga level kabupaten/kota. Data otomatis mengikuti KONI Kabupaten/Kota aktif, sehingga parent dan tingkat tidak dipilih manual."
            listUrl="/organisasi-cabor"
            jenisKode="INDUK_ORGANISASI_CABOR"
            defaultTingkatKode="KABUPATEN_KOTA"
            showTingkatField={false}
            showParentField={false}
            showCaborField={true}
            caborFieldLabel="Cabor"
            enableVerification={false}
            fieldLayout={{ id_cabor: { colsize: 12 } }}
            parentFilter={(item) =>
              ["KONI", "INDUK_ORGANISASI_CABOR"].includes(
                String(item?.jenis_kode || "").toUpperCase(),
              )
            }
          />
        }
      />
    ),
  },
  7503: {
    groups: klubOnlyGroups,
    to: "/organisasi/klub",
    comp: (
      <MainContent
        title="Klub Olahraga"
        content={
          <OrganizationManagementPage
            title="Klub Olahraga"
            description="Pengelolaan klub olahraga milik Induk Organisasi Cabor aktif. Parent organisasi dan tingkat otomatis mengikuti context Induk Organisasi Cabor yang sedang dipakai."
            listUrl="/organisasi-klub"
            jenisKode="KLUB"
            defaultTingkatKode="LAINNYA"
            showTingkatField={false}
            showParentField={false}
            showCaborField={true}
            enableVerification={false}
            listColumnsOverride={[
              "no",
              "logo",
              "nama_singkat",
              "nama",
              "cabor_name",
              "parent_name",
              "telepon",
              "aktif",
              "action",
            ]}
            parentFilter={(item) =>
              String(item?.jenis_kode || "").toUpperCase() ===
              "INDUK_ORGANISASI_CABOR"
            }
          />
        }
      />
    ),
  },
  7504: {
    groups: dataCaborGroups,
    to: "/master/nomor-pertandingan",
    comp: (
      <MainContent
        title="Nomor Pertandingan"
        content={<NomorPertandinganManagementPage />}
      />
    ),
  },
  75010: {
    groups: [2, 3],
    to: "/data-cabor/rekapitulasi",
    comp: (
      <MainContent
        title="Rekapitulasi"
        content={<CaborRekapitulasiPage />}
      />
    ),
  },
  75011: {
    groups: [3],
    to: "/data-cabor/monitoring-aktifitas",
    comp: (
      <MainContent
        title="Monitoring Aktifitas"
        content={<CaborMonitoringAktifitasPage />}
      />
    ),
  },
  7505: {
    groups: allGroups,
    to: "/profile/keanggotaan",
    comp: (
      <MainContent
        title="Keanggotaan"
        content={<PersonalMembershipHistoryPage />}
      />
    ),
  },
  7506: {
    groups: personalGroups,
    to: "/profile/pendidikan",
    comp: (
      <MainContent
        title="Pendidikan"
        content={<PersonalEducationHistoryPage />}
      />
    ),
  },
  7507: {
    groups: personalGroups,
    to: "#",
    comp: <MainContent title="Capaian" content={<Dashboard />} />,
  },
  7508: {
    groups: personalGroups,
    to: "/profile/prestasi",
    comp: (
      <MainContent title="Prestasi" content={<PersonalAchievementPage />} />
    ),
  },
  7509: {
    groups: personalGroups,
    to: "/profile/sertifikasi",
    comp: (
      <MainContent
        title="Sertifikasi"
        content={<PersonalCertificationPage />}
      />
    ),
  },
  7700: {
    groups: organizationCapaianGroups,
    to: "#",
    comp: <MainContent title="Rekapitulasi Capaian" content={<Dashboard />} />,
  },
  7701: {
    groups: organizationCapaianGroups,
    to: "/capaian/prestasi-induk-organisasi",
    comp: (
      <MainContent
        title="Poin Prestasi Induk Organisasi"
        content={<CapaianPrestasiIndukOrganisasiPage />}
      />
    ),
  },
  7702: {
    groups: organizationCapaianGroups,
    to: "/capaian/prestasi-cabor",
    comp: (
      <MainContent
        title="Poin Prestasi Cabor"
        content={<CapaianPrestasiCaborPage />}
      />
    ),
  },
  7703: {
    groups: organizationCapaianGroups,
    to: "/capaian/prestasi-klub",
    comp: (
      <MainContent
        title="Poin Prestasi Klub Olahraga"
        content={<CapaianPrestasiKlubPage />}
      />
    ),
  },
  7704: {
    groups: organizationCapaianGroups,
    to: "/capaian/prestasi-sdm",
    comp: (
      <MainContent
        title="Poin Prestasi SDM"
        content={<CapaianPrestasiSDMPage />}
      />
    ),
  },
  7705: {
    groups: organizationCapaianGroups,
    to: "/capaian/sdm-tersertifikasi",
    comp: (
      <MainContent
        title="SDM Tersertifikasi"
        content={<CapaianSertifikasiSDMPage />}
      />
    ),
  },
  7800: {
    groups: verificationSubmissionGroups,
    to: "#",
    comp: <MainContent title="Ajuan Verifikasi" content={<Dashboard />} />,
  },
  7801: {
    groups: verificationSubmissionGroups,
    to: "/ajuan-verifikasi/prestasi",
    comp: (
      <MainContent
        title="Prestasi"
        content={<VerificationAchievementSubmissionPage />}
      />
    ),
  },
  7802: {
    groups: verificationSubmissionGroups,
    to: "/ajuan-verifikasi/sertifikasi",
    comp: (
      <MainContent
        title="Sertifikasi"
        content={<VerificationCertificationSubmissionPage />}
      />
    ),
  },
  8000: {
    groups: adminGroups,
    to: "#",
    comp: <MainContent title="Master Data" content={<Dashboard />} />,
  },
  8004: {
    groups: adminGroups,
    to: "/master/personal-field",
    comp: (
      <MainContent title="Personal Field" content={<PersonalFieldCatalog />} />
    ),
  },
  8005: {
    groups: adminGroups,
    to: "/master/reference-data",
    comp: page("Reference Data", "Pengelolaan reference data `r_*`."),
  },
  9000: {
    groups: administrasiPenggunaGroups,
    to: "#",
    comp: <MainContent title="Administrasi" content={<Dashboard />} />,
  },
  9009: {
    groups: administrasiPenggunaGroups,
    to: "/administrasi/pengelolaan-pengguna",
    comp: (
      <MainContent
        title="Pengelolaan Pengguna"
        content={<PengelolaanPenggunaPage />}
      />
    ),
  },
  9001: {
    groups: systemGroups,
    to: "/administrasi/users",
    comp: <MainContent title="User" content={<UserAdministrationPage />} />,
  },
  9002: {
    groups: systemGroups,
    to: "/administrasi/groups",
    comp: <MainContent title="Group" content={<GroupManagementPage />} />,
  },
  9004: {
    groups: systemGroups,
    to: "/administrasi/permissions",
    comp: (
      <MainContent title="Permission" content={<PermissionManagementPage />} />
    ),
  },
  9005: {
    groups: systemGroups,
    to: "/administrasi/menus",
    comp: <MainContent title="Menu" content={<MenuManagementPage />} />,
  },
  9006: {
    groups: systemGroups,
    to: "/administrasi/settings",
    comp: <MainContent title="Setting" content={<SettingsManagementPage />} />,
  },
  9007: {
    groups: systemGroups,
    to: "/administrasi/user-contexts",
    comp: (
      <MainContent
        title="User Context"
        content={<UserContextManagementPage />}
      />
    ),
  },
  9008: {
    groups: systemGroups,
    to: "/administrasi/audit-log",
    comp: (
      <MainContent
        title="Audit Log"
        content={
          <SystemTablePage
            title="Audit Log"
            url="/system/audit-logs"
            description="50 aktivitas sistem terbaru."
          />
        }
      />
    ),
  },
  9100: {
    groups: [1, 3],
    to: "/laporan-masalah",
    comp: <MainContent title="Laporan Masalah" content={<IssueManagementPage />} />,
  },
  9998: {
    groups: personalGroups,
    to: "/profil-saya",
    comp: <MainContent title="Profil Saya" content={<MyProfilePage />} />,
  },
  9990: {
    groups: allGroups,
    to: "#",
    comp: <MainContent title="Pengaturan & Bantuan" content={<Dashboard />} />,
  },
  9991: {
    groups: allGroups,
    to: "/ubah-password",
    comp: <MainContent title="Ubah Password" content={<ChangePasswordPage />} />,
  },
  9992: {
    groups: allGroups,
    to: "/panduan-penggunaan",
    comp: <MainContent title="Panduan Penggunaan Sistem" hideHeader content={<SystemGuidePage />} />,
  },
  9993: {
    groups: allGroups,
    to: "/laporkan-masalah",
    comp: <MainContent title="Laporkan Masalah" content={<IssueReportPage />} />,
  },
  10000: { groups: allGroups, to: "/logout", comp: <Logout /> },
};
